import React, { Component } from 'react';
import IconTableHead from '../common/IconTableHead';

const LIGHT_SHADING_COLOR = '#b8d3ff';

export class StatBox extends Component {
  render() {
    return (
      <div className='card' style={{ backgroundColor: LIGHT_SHADING_COLOR }}>
        <div className='card-body'>
          <div className='row'>
            <div className='col-6'>
              <h3 className='mb-0 text-left'>{this.props.number}</h3>
            </div>
            <div className='col-6'>
              <h3 className='text-right'>
                <IconTableHead name={this.props.iconName} />
              </h3>
            </div>
          </div>
          <div className='row'>
            <div className='col-6'>
              <h4 className='mb-0 text-left'>{this.props.title}</h4>
            </div>
            <div className='col-6'>
              <p className='text-right text-danger'>
                {'+' + this.props.delta}
                <span className='text-black ml-1'>
                  <small>{'(' + this.props.period + ')'}</small>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default StatBox;
